// Role constants
export const Role = {
    ADMIN: { value: 'ADMIN', label: 'Administrateur' },
    MANAGER: { value: 'MANAGER', label: 'Manager' }
};

// Client types
export const ClientType = {
    DISTRIBUTOR: { value: 'DISTRIBUTOR', label: 'Distributeur' },
    RETAILER: { value: 'RETAILER', label: 'Revendeur' } 
};

// Navigation items
export const NAV_ITEMS = [
    {
        label: 'Tableau de bord',
        path: '/dashboard',
        icon: 'LayoutDashboard',
        roles: ['ADMIN', 'MANAGER'],
    },
    {
        label: 'Produits',
        path: '/products',
        icon: 'ShoppingBag',
        roles: ['ADMIN', 'MANAGER'],
    },
    {
        label: 'Clients',
        path: '/Clients',
        icon: 'Users',
        roles: ['ADMIN', 'MANAGER']
    },
    {
        label: 'Commandes',
        path: '/orders',
        icon: 'ClipboardList',
        roles: ['ADMIN', 'MANAGER'],
    },

    {
        label: 'Bon de livraison',
        path: '/delivery-notes',
        icon: 'ClipboardList',
        roles: ['ADMIN', 'MANAGER', 'SALES_REP'],
    },

   
    
    // {
    //     label: 'Inventaire',
    //     path: '/inventory',
    //     icon: 'Layers',
    //     roles: ['ADMIN', 'MANAGER', 'WAREHOUSE_MANAGER'],
    // },

    {
        label: 'Factures',
        path: '/invoices',
        icon: 'ClipboardList',
        roles: ['ADMIN', 'MANAGER'],
    },
    
    // {
    //     label: 'Distributeurs',
    //     path: 'distributors',
    //     icon: 'ShoppingBag',
    //     roles: ['ADMIN', 'MANAGER']
    // },
    // {
    //     label: 'Revendeurs',
    //     path: '/retailers',
    //     icon: 'Store',
    //     roles: ['ADMIN', 'MANAGER', 'SALES_REP']
    // },
    
    // {
    //     label: 'Fournisseurs',
    //     path: '/suppliers',
    //     icon: 'Truck',
    //     roles: ['ADMIN', 'MANAGER', 'WAREHOUSE_MANAGER'],
    // },
    {
        label: 'Utilisateurs',
        path: '/users',
        icon: 'UserCog',
        roles: ['ADMIN', 'MANAGER'],
    },
    {
        label: 'Rapports',
        path: '/reports',
        icon: 'BarChart2',
        roles: ['ADMIN', 'MANAGER'],
    },
    // {
    //     label: 'Settings',
    //     path: '/settings',
    //     icon: 'Settings',
    //     roles: ['ADMIN'],
    // },
];